/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects";

import {
  LOAD_SALES_RETURN_RECORDS_META_DATA,
  LOAD_SALES_RETURN,
  CREATE_SALES_RETURN,
  UPDATE_SALES_RETURN,
  DELETE_SALES_RETURN,
  LOAD_PARTIES_TRANSACTION,
  LOAD_SALES_RETURN_CATEGORY,
  CREATE_SALES_RETURN_PARTIES_CATEGORY,
  LOAD_PARTY_VENDOR_ADDRESS,
  CREATE_PARTY_VENDOR_ADDRESS,
  LOAD_SALES_RETURN_DASHBOARD_TRANSACTION,
  LOAD_SALES_RETURN_TOTAL,
  LOAD_RETURN_TOTAL_SALES_PAID,
  LOAD_RETURN_TOTAL_SALES_UNPAID,
  LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE,
} from "./constants";

import {
  loadSalesInvoice,
  loadSalesInvoiceSuccess,
  loadSalesInvoiceError,
  createSalesInvoiceListSuccess,
  createSalesInvoiceListError,
  updateSalesInvoiceListSuccess,
  updateSalesInvoiceListError,
  deleteSalesInvoiceListSuccess,
  deleteSalesInvoiceListError,
  loadSalesInvoiceRecordsMetaDataError,
  loadSalesInvoiceRecordsMetaDataSuccess,
  loadPartiesTransaction,
  loadPartiesTransactionSuccess,
  loadPartiesTransactionError,
  loadPartiesCategory,
  loadPartiesCategorySuccess,
  loadPartiesCategoryError,
  createPartiesCategoryListSuccess,
  createPartiesCategoryListError,
  loadPartyVendorAddress,
  loadPartyVendorAddressSuccess,
  loadPartyVendorAddressError,
  createPartyVendorAddressSuccess,
  createPartyVendorAddressError,
  loadDashboardTransactions,
  loadDashboardTransactionsSuccess,
  loadDashboardTransactionsError,
  loadSalesTotal,
  loadSalesTotalSuccess,
  loadSalesTotalError,
  loadTotalPaid,
  loadTotalPaidSuccess,
  loadTotalPaidError,
  loadTotalUnPaid,
  loadTotalUnPaidSuccess,
  loadTotalUnPaidError,
  loadSearchImeiBarcodeList,
  loadSearchImeiBarcodeListSuccess,
  loadSearchImeiBarcodeListError,
} from "./actions";

import {
  loadSalesInvoiceDetails,
  createSalesInvoiceDetails,
  updateSalesInvoiceDetails,
  deleteSalesInvoiceDetails,
  loadRecordsMetaData,
  loadPartiesTransactionDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadDashboardTransactionsDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadTotalSalesDetails,
  loadSearchImeiBarcodeDetails,
} from "./remotes";
import { isEmpty } from "lodash";

function* loadSalesInvoiceSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadSalesInvoice(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesInvoiceDetails, salesInvoiceList);

        if (result) {
          yield put(loadSalesInvoiceSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesInvoiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadSearchImeiBarcodeDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_SEARCH_IMEI_BARCODE),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadSearchImeiBarcodeList(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadSearchImeiBarcodeDetails,
          salesInvoiceList
        );

        if (result) {
          yield put(loadSearchImeiBarcodeListSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSearchImeiBarcodeListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadDashboardTransactionsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_DASHBOARD_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadDashboardTransactions(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadDashboardTransactionsDetails,
          transactionsList
        );

        if (result) {
          yield put(loadDashboardTransactionsSuccess(result));
        }
      } catch (error) {
        yield put(
          loadDashboardTransactionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadSalesTotalDetailsSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_TOTAL),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadSalesTotal(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalSalesDetails, transactionsList);

        if (result) {
          yield put(loadSalesTotalSuccess(result));
        }
      } catch (error) {
        yield put(
          loadSalesTotalError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadTotalPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_RETURN_TOTAL_SALES_PAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalPaidDetails, transactionsList);

        if (result) {
          yield put(loadTotalPaidSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* loadTotalUnPaidSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_RETURN_TOTAL_SALES_UNPAID),
    });

    const { explicitLoad } = load;
    const { transactionsList } = explicitLoad || {};
    yield put(loadTotalUnPaid(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadTotalUnPaidDetails, transactionsList);

        if (result) {
          yield put(loadTotalUnPaidSuccess(result));
        }
      } catch (error) {
        yield put(
          loadTotalUnPaidError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartyVendorAddressSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTY_VENDOR_ADDRESS),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPartyVendorAddress(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartyVendorAddressDetails,
          salesInvoiceList
        );

        if (result) {
          yield put(loadPartyVendorAddressSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartyVendorAddressSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_PARTY_VENDOR_ADDRESS),
    });

    const { partyAddress } = create || {};

    if (create) {
      try {
        const result = yield call(
          createPartyVendorAddressDetails,
          partyAddress
        );
        if (result) {
          yield put(createPartyVendorAddressSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartyVendorAddressError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesTransactionSaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_PARTIES_TRANSACTION),
    });

    const { explicitLoad } = load;
    const { salesInvoiceList } = explicitLoad || {};
    yield put(loadPartiesTransaction(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(
          loadPartiesTransactionDetails,
          salesInvoiceList
        );

        if (result) {
          yield put(loadPartiesTransactionSuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesTransactionError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_SALES_RETURN),
    });

    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(createSalesInvoiceDetails, salesInvoiceList);
        if (result) {
          yield put(createSalesInvoiceListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createSalesInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* updatePartiesSaga() {
  while (true) {
    const { update } = yield race({
      update: take(UPDATE_SALES_RETURN),
    });
    const { salesInvoiceList } = update || {};

    if (update) {
      try {
        const result = yield call(updateSalesInvoiceDetails, salesInvoiceList);
        if (result) {
          yield put(updateSalesInvoiceListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          updateSalesInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}
function* deletePartiesSaga() {
  while (true) {
    const { create } = yield race({
      create: take(DELETE_SALES_RETURN),
    });
    const { salesInvoiceList } = create || {};

    if (create) {
      try {
        const result = yield call(deleteSalesInvoiceDetails, salesInvoiceList);
        if (result) {
          yield put(deleteSalesInvoiceListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          deleteSalesInvoiceListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadPartiesCategorySaga() {
  while (true) {
    const load = yield race({
      explicitLoad: take(LOAD_SALES_RETURN_CATEGORY),
    });
    const { explicitLoad } = load;
    const { categoryList } = explicitLoad || {};
    yield put(loadPartiesCategory(explicitLoad)); // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPartiesCategoryDetails, categoryList);

        if (result) {
          yield put(loadPartiesCategorySuccess(result));
        }
      } catch (error) {
        yield put(
          loadPartiesCategoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* createPartiesCategorySaga() {
  while (true) {
    const { create } = yield race({
      create: take(CREATE_SALES_RETURN_PARTIES_CATEGORY),
    });
    const { categoryList } = create || {};

    if (create) {
      try {
        const result = yield call(createPartiesCategoryDetails, categoryList);
        if (result) {
          yield put(createPartiesCategoryListSuccess(result.data));
          // console.log(result.data, "result");
        }
      } catch (error) {
        yield put(
          createPartiesCategoryListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        );
      }
    }
  }
}

function* loadSalesInvoiceMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_SALES_RETURN_RECORDS_META_DATA),
    });
    const userName = localStorage.getItem("authData");

    const userNameDetails = JSON.parse(userName);

    const userInfoDetails = !isEmpty(userNameDetails)
      ? userNameDetails.user.organizations[0].organizationId
      : "";

    try {
      const state = yield call(loadRecordsMetaData, "getstate", "post");
      const biller = yield call(
        loadRecordsMetaData,
        "getdropdownbillerdata",
        "post",
        {
          organizationId: userInfoDetails,
        }
      );

      let recordsMetaData = {
        stateOptions:
          (state &&
            state &&
            state.length > 0 &&
            state.map((c) =>
              Object.assign(
                {},
                {
                  label: c.stateName,
                  shortCode: c.shortCode,
                  value: c._id,
                }
              )
            )) ||
          [],
      
        billerOptions:
          (biller &&
            biller &&
            biller.length > 0 &&
            biller.map((c) =>
              Object.assign(
                {},
                {
                  label: c.name,
                  value: c.userId,
                }
              )
            )) ||
          [],
      };

      yield put(loadSalesInvoiceRecordsMetaDataSuccess(recordsMetaData));
    } catch (error) {
      yield put(
        loadSalesInvoiceRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      );
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadSalesInvoiceSaga(),
    loadSearchImeiBarcodeDetailsSaga(),
    deletePartiesSaga(),
    updatePartiesSaga(),
    createPartiesSaga(),
    loadSalesInvoiceMetaDataSaga(),
    loadPartiesTransactionSaga(),
    createPartiesCategorySaga(),
    createPartyVendorAddressSaga(),
    loadPartyVendorAddressSaga(),
    loadPartiesCategorySaga(),
    loadDashboardTransactionsSaga(),
    loadSalesTotalDetailsSaga(),
    loadTotalPaidSaga(),
    loadTotalUnPaidSaga(),
  ]);
}
